import React from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";

import PaperCard1 from "./PaperCards/PaperCard1";
import PaperCard2 from "./PaperCards/PaperCard2";
import MenuNavigation from "./MenuNavigation";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <Typography
      component="div"
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box paddingTop={2}>{children}</Box>}
    </Typography>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const useStyles = makeStyles((theme) => ({
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    border: "2px solid #000",
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
  },
  iframe: {
    width: "100%",
    height: "70vh",
  },
  root: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper,
  },
  cards: {
    display: "flex",
    flexWrap: "wrap",
    "& > *": {
      margin: theme.spacing(1),
      width: "50%", //theme.spacing(90),
      height: theme.spacing(30),
    },
  },
}));

export default function SimpleTabs() {
  const classes = useStyles();
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <div className={classes.root}>
      <AppBar position="static">
        <Tabs
          value={value}
          onChange={handleChange}
          variant="scrollable"
          scrollButtons="auto"
          aria-label="simple tabs example"
        >
          <Tab label="Home" {...a11yProps(0)} />
          <Tab label="Business" {...a11yProps(1)} />
          <Tab label="COVID-19 SA" {...a11yProps(2)} />
          <Tab label="IOL News" {...a11yProps(3)} />
          <Tab label="Movies" {...a11yProps(4)} />
          {/* <Tab label="Games" {...a11yProps(4)} /> */}
        </Tabs>
      </AppBar>
      <TabPanel value={value} index={0}>
        <MenuNavigation />
      </TabPanel>
      <TabPanel value={value} index={1}>
        <iframe
          frameBorder="0"
          className={classes.iframe}
          src="https://businesstech.co.za/news/"
        >
          <p>Your browser does not support iframes.</p>
        </iframe>
      </TabPanel>
      <TabPanel value={value} index={2} className={classes.iframe}>
        <iframe
          frameBorder="0"
          className={classes.iframe}
          src="https://www.worldometers.info/coronavirus/country/south-africa/"
        >
          <p>Your browser does not support iframes.</p>
        </iframe>
      </TabPanel>

      <TabPanel value={value} index={3} className={classes.iframe}>
        <iframe
          frameBorder="0"
          className={classes.iframe}
          src="https://www.iol.co.za/news"
        >
          <p>Your browser does not support iframes.</p>
        </iframe>
      </TabPanel>
      <TabPanel value={value} index={4} className={classes.iframe}>
        <iframe
          frameBorder="0"
          className={classes.iframe}
          src="https://nites.tv/latest-movies-added/"
        >
          <p>Your browser does not support iframes.</p>
        </iframe>
      </TabPanel>
      {/* <TabPanel value={value} index={4} className={classes.iframe}>
        <iframe
          src="https://www.baptistebrunet.com/games/tetris_js/"
          className={classes.iframe}
          scrolling="no"
          frameborder="0"
          allowTransparency="true"
        ></iframe>
      </TabPanel> */}
    </div>
  );
}
